// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sidebar {
    padding: 30px;
    background-color: #f4f4f4;
    border-right: 1px solid #ddd;
    overflow-y: auto;
    width: 28%;
}

.sidebar-content {
    margin-top: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/components/componentsCSS/Sidebar.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,yBAAyB;IACzB,4BAA4B;IAC5B,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["\n.sidebar {\n    padding: 30px;\n    background-color: #f4f4f4;\n    border-right: 1px solid #ddd;\n    overflow-y: auto;\n    width: 28%;\n}\n\n.sidebar-content {\n    margin-top: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
